import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../user-profile-block/index.js';
import css_248z from './account-access-mobile.scss.js';

class AccountAccessMobile extends s {
    constructor() {
        super(...arguments);
        this.isAuthenticated = false;
        this.userName = '';
        this.avatarUrl = '';
        this.loginUrl = '';
        this.registerUrl = '';
        this.logoutUrl = '';
        this.accountManagementUrl = '';
        this.accountManagementText = '';
        this.loginButtonText = '';
        this.registerButtonText = '';
        this.logoutButtonText = '';
        this.disabled = false;
    }
    renderAuthenticatedView() {
        return $ `<user-profile-block .name="${this.userName}" .link="${this.accountManagementUrl}" .subtitle="${this.accountManagementText}" .avatarUrl="${this.avatarUrl}"></user-profile-block>`;
    }
    renderGuestView() {
        return $ `<primary-cta .label="${this.loginButtonText}" .type="button" .disabled="${this.disabled}" .href="${this.loginUrl}"></primary-cta><button-primary .label="${this.registerButtonText}" .type="button" .disabled="${this.disabled}" .href="${this.registerUrl}"></button-primary>`;
    }
    render() {
        return $ `<div class="account-access-mobile">${this.isAuthenticated
            ? this.renderAuthenticatedView()
            : this.renderGuestView()}</div>`;
    }
}
AccountAccessMobile.styles = css_248z;
__decorate([
    e({ type: Boolean })
], AccountAccessMobile.prototype, "isAuthenticated", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "userName", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "avatarUrl", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "loginUrl", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "registerUrl", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "logoutUrl", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "accountManagementUrl", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "accountManagementText", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "loginButtonText", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "registerButtonText", void 0);
__decorate([
    e({ type: String })
], AccountAccessMobile.prototype, "logoutButtonText", void 0);
__decorate([
    e({ type: Boolean })
], AccountAccessMobile.prototype, "disabled", void 0);
customElements.define('account-access-mobile', AccountAccessMobile);

export { AccountAccessMobile };
